module.exports = import("https://unpkg.com/@tailwindcss/browser@4");;